import {initElements} from "../define/shared";

export default function initGlossaryHeader() {
    initElements(".glossary-header", header => {
        const search = header.querySelector(".search");
        const input = search.querySelector("input");
        const searchResults = search.querySelector(".search-results");
        const loader = search.querySelector(".loader");
        const siteHeader = document.querySelector(".siteHeader");

        let typingTimer;

        input.addEventListener("keyup", () => {
            clearTimeout(typingTimer);
            if (input.value.trim().length >= 2) {
                typingTimer = setTimeout(getSearchResults, 250);
            }
        });

        input.addEventListener("search", () => {
            search.classList.remove("is--open");
        });

        document.addEventListener("click", (e) => {
            if (e.target !== input) {
                search.classList.remove("is--open");
            }
        });

        function getSearchResults() {
            loader.classList.add("is--active");
            fetch(window.RES.base + "wa-theme/v1/word", {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                    'X-WP-Nonce': window.RES.nonce_wp,
                },
                body: JSON.stringify({
                    s: input.value.trim(),
                    nonce: window.RES.nonce
                })
            }).then(response => response.json())
                .then(data => {
                    loader.classList.remove("is--active");

                    if (data.success) {
                        searchResults.innerHTML = data.html;
                        searchResults.querySelectorAll(".link").forEach(link => initClick(link));
                        search.classList.add("is--open");
                    }
                });
        }

        function initClick(link) {
            link.addEventListener("click", (e) => {
                const body = document.querySelector("body")
                if (!(body.classList.contains("tax-letter") && body.classList.contains(`term-${link.dataset.letter}`))) {
                    return;
                }
                e.preventDefault();
                const slug = link.dataset.slug;
                const desc = document.querySelector(`#${slug}`);
                const words = document.querySelectorAll(".word");

                if (desc && words) {
                    words.forEach(word => {
                        word.classList.remove("is--active");
                        if (word.dataset.slug === slug) {
                            word.classList.add("is--active");
                        }
                    });
                    document.querySelectorAll(".post").forEach(item => item.classList.remove("is--open"));
                    desc.classList.add("is--open");

                    window.scrollTo({
                        left: 0,
                        top: desc.offsetTop - siteHeader.offsetHeight,
                        behavior: "smooth"
                    });

                    window.history.replaceState(null, null, `#${slug}`);
                }
            });
        }
    });
}
